export default __webpack_public_path__ + "static/media/delievers2.ed09c3ef.jpeg";